import { Pipe, PipeTransform } from '@angular/core';
import { OverlayField } from './details-overlay.model';
import { L10nTranslationService } from 'angular-l10n';
import { Column } from '@miq/catalog';

@Pipe({
  name: 'labelFormatter',
  standalone: false,
})
export class LabelFormatterPipe implements PipeTransform {
  constructor(private translationService: L10nTranslationService) {}

  transform(
    columns: Column[],
    subsetConfig: Pick<OverlayField, 'label' | 'labelFn'>
  ): string | { [attr: string]: any } {
    const { label, labelFn } = subsetConfig;
    const value = labelFn && labelFn(columns).toString();

    return value ?? this.translationService.translate(label);
  }
}
